import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureGuidelineGhGasMgmtReport = () => {
  const [opened, { open, close }] = useDisclosure();
  return (
    <Box>
      <Button color="inherit" startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>
      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="การรายงานผลการดำเนินงานและผลลัพธ์การจัดการก๊าซเรือนกระจก"
        description={
          <>
            <Typography sx={{ textIndent: 90 }}>
              ให้เปิดเผยข้อมูลการปล่อยก๊าซเรือนกระจกตามมาตรฐานสากลหรือเทียบเท่าโดยระบุชื่อผู้ทวนสอบการจัดทำคาร์บอนฟุตพริ้นท์ขององค์กรที่ขึ้นทะเบียนกับองค์การบริหารจัดการก๊าซเรือนกระจก
              (อบก.)
              หรือผู้ทวนสอบที่บริษัทเห็นว่ามีผลงานเป็นที่ยอมรับอย่างแพร่หลายในระดับสากล
              รวมทั้งเปิดเผยแนวนโยบายในเรื่องนี้ของคณะกรรมการบริษัทที่สะท้อนให้เห็นถึงความมุ่งมั่นในการลดผลกระทบทางลบต่อสิ่งแวดล้อมหรือการจัดการการปล่อยก๊าซเรือนกระจกและหากเป็นช่วงเริ่มต้นหรืออยู่ระหว่างดำเนินการให้เปิดเผยระยะเวลาการดำเนินการให้ผู้ลงทุนทราบด้วย
              ทั้งนี้
              ในกรณีที่บริษัทไม่ได้จัดทำข้อมูลการปล่อยก๊าซเรือนกระจกให้ระบุว่า
              “ไม่มีข้อมูล” พร้อมแสดงเหตุผลประกอบ
            </Typography>
            <Typography
              fontWeight="bold"
              sx={{
                textDecoration: 'underline',
                textIndent: 90,
              }}
              mb={-2}
            >
              คำแนะนำหรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              การจัดการเพื่อลดปัญหาก๊าซเรือนกระจก <br />
              การรายงานข้อมูลการจัดการเพื่อลดปัญหาก๊าซเรือนกระจกสะท้อนให้เห็นถึงกิจกรรมที่เกี่ยวข้องกับการใช้พลังงาน
              ทรัพยากร รวมทั้งการเกิดขยะของเสีย
              และมลพิษจากกระบวนการดำเนินธุรกิจซึ่งเป็นสาเหตุของปัญหาก๊าซเรือนกระจกที่นำไปสู่ภาวะโลกร้อนและการเปลี่ยนแปลงสภาพภูมิอากาศ
              นอกจากนี้
              บริษัทควรเปิดเผยข้อมูลเกี่ยวกับวิธีการบริหารจัดการและผลลัพธ์ที่เกิดขึ้นจากการลดผลกระทบดังกล่าวในช่วงเวลาที่ผ่านมารวมถึงเป้าหมายการลดปัญหาก๊าซเรือนกระจกของธุรกิจในอนาคตโดยมีแนวทางการเปิดเผยข้อมูล
              ดังนี้
              อธิบายกิจกรรมหลักที่ก่อให้เกิดก๊าซเรือนกระจกจากการดำเนินธุรกิจตั้งแต่ต้นน้ำถึงปลายน้ำ
              เช่น การได้มาซึ่งวัตถุดิบ การผลิต การขนส่งการจัดการขยะและของเสีย
              โดยแบ่งเป็น 2 ด้าน ได้แก่
              <li style={{ marginBottom: '4px' }}>
                การปล่อยก๊าซเรือนกระจกทางตรง เช่น การเผาไหม้ของเครื่องจักร
                การใช้พาหนะขององค์กร (ที่องค์กรเป็นเจ้าของ)
                การใช้สารเคมีในการบำบัดน้ำเสีย และระบบทำความเย็น
              </li>
              <li style={{ marginBottom: '4px' }}>
                การปล่อยก๊าซเรือนกระจกทางอ้อม เช่น
                การซื้อไฟฟ้ามาใช้ในการดำเนินธุรกิจ
                ระบุวิธีการบริหารจัดการเพื่อลดการปล่อยก๊าซเรือนกระจกรวมทั้งอาจแสดงผลลัพธ์ที่เกิดขึ้นในปีที่ผ่านมา
                และเปรียบเทียบกับข้อมูลในปีก่อนหน้า
                ระบุปริมาณการปล่อยก๊าซเรือนกระจกทั้งทางตรงและทางอ้อมรวมทั้งผลรวมปริมาณการปล่อยก๊าซเรือนกระจกของทั้งองค์กรโดยเปรียบเทียบกับข้อมูลในปีก่อนหน้า
                (ถ้ามี) ระบุเป้าหมาย
                แนวทางและกลยุทธ์เพื่อลดปัญหาก๊าซเรือนกระจกจากธุรกิจในอนาคต
              </li>
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              เพื่อให้เกิดความเชื่อมั่นต่อข้อมูลการปล่อยก๊าซเรือนกระจกที่เปิดเผยให้บริษัทระบุมาตรฐานที่ใช้ในการคำนวณ
              และผู้ทวนสอบ/ผู้ที่ให้การรับรองข้อมูลก๊าซเรือนกระจก เช่น
              บริษัทได้ประเมินตามแนวทางขององค์การบริหารจัดการก๊าซเรือนกระจก
              (อบก.) และทวนสอบข้อมูลดังกล่าว
              โดยระบุชื่อผู้ทวนสอบที่บริษัทเห็นว่ามีผลงานเป็นที่ยอมรับอย่างแพร่หลายในระดับสากลที่บริษัทใช้บริการ
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              ทั้งนี้
              หากเป็นการทวนสอบโดยผู้ที่ไม่ได้อยู่ในรายชื่อที่ขึ้นทะเบียนกับอบก.
              จะต้องกระทำโดยผู้ทวนสอบที่บริษัทพิจารณาว่ามีความเหมาะสมและมีความน่าเชื่อถือเพียงพอ
              เช่น
              เป็นผู้ทวนสอบซึ่งมีผลงานเป็นที่ยอมรับอย่างแพร่หลายในประเทศอันเป็นที่ตั้งของบริษัทนั้น
              เป็นผู้ทวนสอบที่มีมาตรฐานการปฏิบัติงานในระดับสากลเป็นผู้ทวนสอบที่มีเครือข่ายกว้างขวางในระดับสากล
              (international firm)
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              บริษัทสามารถศึกษาแนวทางการประเมินคาร์บอนฟุตพริ้นท์ขององค์กรและแนวทางการทวนสอบตลอดจนรายชื่อผู้ทวนสอบได้จากองค์การบริหารจัดการก๊าซเรือนกระจก(อบก.)
              ได้ที่{' '}
              <a href="https://www.tgo.or.th/" target="_blank" rel="noreferrer">
                https://www.tgo.or.th/
              </a>{' '}
              หรือ{' '}
              <a
                href="http://thaicarbonlabel.tgo.or.th/verifier/organization/organization.pnc"
                target="_blank"
                rel="noreferrer"
              >
                http://thaicarbonlabel.tgo.or.th/verifier/organization/organization.pnc
              </a>
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              ตัวอย่างเช่น <br />
              บริษัทให้ความสำคัญกับการจัดการเพื่อลดปัญหาก๊าซเรือนกระจกโดยพบว่ากิจกรรมของธุรกิจที่มีปริมาณการปล่อยก๊าซเรือนกระจกมากที่สุด
              คือ
              การใช้ไฟฟ้าจากเครื่องปรับอากาศในสำนักงานและการใช้น้ำมันเชื้อเพลิงจากยานพาหนะขององค์กร
              บริษัทจึงมีมาตรการบำรุงรักษาเครื่องปรับอากาศตามแผนอนุรักษ์พลังงานอย่างต่อเนื่องและมีแผนที่จะเปลี่ยนรถยนต์องค์กรเป็นแบบไฮบริดทั้งหมดภายในปี.....
            </Typography>
            <Typography sx={{ textIndent: 90 }} mt={2}>
              ในปี........บริษัทมีปริมาณการปล่อยก๊าซเรือนกระจกทางตรง........ตัน
              (หรือกิโลกรัม) คาร์บอนไดออกไซด์เทียบเท่า
              และปริมาณการปล่อยก๊าซเรือนกระจกทางอ้อม.....ตัน (หรือกิโลกรัม)
              คาร์บอนไดออกไซด์เทียบเท่า รวม................ตัน (หรือกิโลกรัม)
              คาร์บอนไดออกไซด์เทียบเท่าลดลงจากปีก่อน..........ตัน (หรือกิโลกรัม)
              คาร์บอนไดออกไซด์เทียบเท่าต่อปีหรือลดลงร้อยละ......... โดย
              ผู้ทวนสอบ คือ ......
            </Typography>
          </>
        }
      />
    </Box>
  );
};

export default DisclosureGuidelineGhGasMgmtReport;
